module.exports = __webpack_public_path__ + "static/media/rhino.04410614.png";